(() => {
  function initCollectionAccordions(root = document) {
    root.querySelectorAll('[data-bvm-rich-accordion]').forEach((block) => {
      if (block.dataset.bvmReady === 'true') return;
      block.dataset.bvmReady = 'true';

      const items = Array.from(block.querySelectorAll('[data-bvm-rich-accordion-item]'));
      if (!items.length) return;

      const desktop = window.matchMedia("(min-width: 750px)");
      const openFirstDesktop = block.dataset.firstOpenDesktop === 'true';

      function setInitialState() {
        items.forEach((item) => {
          item.open = false;
        });

        if (openFirstDesktop && desktop.matches && items[0]) {
          items[0].open = true;
        }
      }

      setInitialState();

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (!item.open) return;

          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
        });
      });

      if (desktop.addEventListener) {
        desktop.addEventListener('change', setInitialState);
      }
    });

    root.querySelectorAll('[data-bvm-faq-accordion]').forEach((block) => {
      if (block.dataset.bvmReady === 'true') return;
      block.dataset.bvmReady = 'true';

      const items = Array.from(block.querySelectorAll('[data-bvm-faq-accordion-item]'));
      if (!items.length) return;

      let syncing = false;

      items.forEach((item) => {
        item.addEventListener('toggle', () => {
          if (syncing || !item.open) return;

          syncing = true;
          items.forEach((other) => {
            if (other !== item) other.open = false;
          });
          syncing = false;
        });
      });
    });
  }

  function initCollectionBuildCarousels(root = document) {
    root.querySelectorAll('[data-bvm-collection-builds]').forEach((block) => {
      if (block.dataset.bvmCarouselReady === 'true') return;
      block.dataset.bvmCarouselReady = 'true';

      const track = block.querySelector('[data-bvm-collection-build-track]');
      const previous = block.querySelector('[data-bvm-collection-build-prev]');
      const next = block.querySelector('[data-bvm-collection-build-next]');
      if (!track) return;

      const getStep = () => {
        const card = track.querySelector('.bvm-collection-build-card');
        if (!card) return Math.max(280, track.clientWidth * 0.82);
        const styles = window.getComputedStyle(track);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0') || 0;
        return card.getBoundingClientRect().width + gap;
      };

      previous?.addEventListener('click', () => {
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });

      next?.addEventListener('click', () => {
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    });
  }



  function scrollToCollectionAnchor(hash, behavior = 'smooth') {
    if (hash !== '#customer-builds-gallery') return false;

    const target = document.getElementById('customer-builds-gallery');
    if (!target) return false;

    // The Royal Enfield build carousel is a below-fold section using
    // content-visibility for performance. Force it to participate in layout
    // before measuring its position, otherwise some browsers only update the
    // URL hash without moving the viewport.
    target.style.contentVisibility = 'visible';
    target.style.containIntrinsicSize = 'none';

    const header = document.querySelector('.header-wrapper, sticky-header, header');
    const headerHeight = header ? Math.min(header.getBoundingClientRect().height, 140) : 0;
    const offset = Math.max(24, headerHeight + 18);

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        const top = Math.max(0, window.scrollY + target.getBoundingClientRect().top - offset);
        window.scrollTo({ top, behavior });
      });
    });

    return true;
  }

  function initCollectionAnchorNavigation() {
    if (document.documentElement.dataset.bvmCollectionAnchorsReady === 'true') return;
    document.documentElement.dataset.bvmCollectionAnchorsReady = 'true';

    document.addEventListener('click', (event) => {
      const link = event.target.closest("a[href=\"#customer-builds-gallery\"]");
      if (!link) return;

      const target = document.getElementById('customer-builds-gallery');
      if (!target) return;

      event.preventDefault();
      if (window.location.hash !== '#customer-builds-gallery') {
        window.history.pushState(null, '', '#customer-builds-gallery');
      }
      scrollToCollectionAnchor('#customer-builds-gallery', 'smooth');
    });

    window.addEventListener('hashchange', () => {
      scrollToCollectionAnchor(window.location.hash, 'smooth');
    });

    if (window.location.hash === '#customer-builds-gallery') {
      window.setTimeout(() => {
        scrollToCollectionAnchor('#customer-builds-gallery', 'auto');
      }, 80);
    }
  }

  function initCollectionEnhancements(root = document) {
    initCollectionAccordions(root);
    initCollectionBuildCarousels(root);
    initCollectionAnchorNavigation();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initCollectionEnhancements());
  } else {
    initCollectionEnhancements();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCollectionEnhancements(event.target);
  });
})();
